export default __webpack_public_path__ + "static/media/additional.e168b973.svg";